import {
  INIT_URL,
  USER_DATA_SUCCESS,
  USER_DATA_FAIL,
  USER_TOKEN_SET,
  GET_LIST_VAI_TRO_SUCCESS,
  GET_LIST_VAI_TRO_FAIL
} from 'src/constants/ActionTypes';

import { getCookieValue, setCookieValue } from 'util/Common';
import { getSessionStorage, setSessionStorage } from 'src/util/Common';

const INIT_STATE = {
  token: getCookieValue('accessTokenBDT') ? getCookieValue('accessTokenBDT') : '',
  initURL: '',
  authUser: getSessionStorage('auth') ? getSessionStorage('auth') : {},
  vaiTro: [],
  error: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      };
    }

    case USER_TOKEN_SET: {
      return {
        ...state,
        token: action.payload
      };
    }

    case USER_DATA_SUCCESS: {
      setCookieValue('userId', action.data.user.id);
      setSessionStorage('auth', action.data);
      return {
        ...state,
        authUser: action.data,
        error: false
      };
    }

    case USER_DATA_FAIL: {
      setCookieValue('userId', '');
      return {
        ...state,
        authUser: {},
        error: true
      };
    }

    case GET_LIST_VAI_TRO_SUCCESS:
      return {
        ...state,
        vaiTro: action.data,
        error: false
      };

    case GET_LIST_VAI_TRO_FAIL:
      return {
        ...state,
        vaiTro: [],
        error: true
      };

    default:
      return state;
  }
};
